<script>
import { mapActions, mapGetters } from 'vuex';
import StatusTypes from '../../../helpers/enums/statusTypes.enum';

export default {
  data() {
    return {
      appClosingBlocks: [
        'uploadAiFiles',
      ],
    };
  },
  computed: {
    ...mapGetters({
      backgroundActions: 'automation/backgroundActions',
    }),
  },
  watch: {
    backgroundActions() {
      const pendingActions = this.backgroundActions.filter(ba => ba.status === StatusTypes.PENDING);
      if (pendingActions.length) {
        // const runActions = this.backgroundActions.toReversed();
        pendingActions.forEach((action) => {
          if (action.action === 'uploadAiFiles') {
            this.backgroundActionStatusChange({
              action: 'uploadAiFiles',
              assistantId: action.assistantId,
              status: StatusTypes.RUNNING,
            });
            if (action.data && action.data.files && action.data.files.addFiles && action.data.files.addFiles.length) {
              this.uploadBackgroundAiFilesVUEX({
                id: action.id,
                assistantId: action.assistantId,
                files: action.data.files.addFiles,
              });
            }
            if (action.data && action.data.files && action.data.files.removeFiles && action.data.files.removeFiles.length) {
              this.removeBackgroundAiFilesVUEX({
                assistantId: action.assistantId,
                files: action.data.files.removeFiles,
              });
              if (!(action.data && action.data.files && action.data.files.addFiles && action.data.files.addFiles.length)) {
                // This will just trigger the removal of background action since only upload has the ability to remove it because upload
                // and delete are grouped in one action and we do not have the loader for delete.
                this.uploadBackgroundAiFilesVUEX({
                  id: action.id,
                  assistantId: action.assistantId,
                  files: [],
                });
              }
            }
          }
          // if (action.action === 'webScrape') {
          //   this.backgroundActionStatusChange({
          //     action: 'webScrape',
          //     assistantId: action.assistantId,
          //     status: StatusTypes.RUNNING,
          //   });
          // }
        });
      }
    },
  },
  created() {
    // Code to run when the component is created


    // WATCHER FOR PUSHER EVENTS
  },
  mounted() {
    const closeHandler = (e) => {
      const defaultMessage = 'Changes that you made may not be saved.';
      if (this.checkAppClosingBlocks()) {
        e.preventDefault(); // required in some browsers
        e.returnValue = defaultMessage; // required in some browsers
        return defaultMessage; // only works in old browsers
      }
      return false;
    };

    if (window.addEventListener) {
      window.addEventListener('beforeunload', closeHandler, true);
      window.addEventListener('close', closeHandler, true);
    } else if (window.attachEvent) {
      window.attachEvent('onbeforeunload', closeHandler);
      window.addEventListener('close', closeHandler);
    }
  },
  methods: {
    ...mapActions({
      uploadBackgroundAiFilesVUEX: 'automation/uploadBackgroundAiFiles',
      removeBackgroundAiFilesVUEX: 'automation/removeBackgroundAiFiles',
      backgroundActionStatusChange: 'automation/backgroundActionStatusChange',
    }),
    /**
     * Method will check all the store variables listed as blockers to determine if the closing or reloading of the page is allowed.
     * User is still available to force the close/reload but it will get the native info popup first.
     */
    checkAppClosingBlocks() {
      return this.appClosingBlocks.some(blocker => this.backgroundActions.filter(ba => ba.action === blocker && [StatusTypes.PENDING, StatusTypes.RUNNING].includes(ba.status)).length > 0);
    },
  },
};
</script>
